import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
    return (
        <section className="text-center text-white pt-5 pb-3">
            <h6 className="lh-lg">Designed & Developed By Md. Raisul Islam</h6>
            <ul>
                <a className="text-white me-4" href="https://www.facebook.com/raisulislamnibir.24" target="_blank"><FontAwesomeIcon icon={faFacebook} className="fa-2x"/></a>
                <a className="text-white me-4" href="https://www.linkedin.com/in/md-raisul-islam-ba1613168/" target="_blank"><FontAwesomeIcon icon={faLinkedin} className="fa-2x"/></a>
                <a className="text-white me-4" href="https://github.com/RaisulIslam24" target="_blank"><FontAwesomeIcon icon={faGithub} className="fa-2x"/></a>
            </ul>
            <h6>Copyright © 2021</h6>
        </section>
    );
};

export default Footer;